// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__5QDm1","txt":"Footer_txt__Pt6vA","line":"Footer_line__ZgTRV","info":"Footer_info__GanwO"};